import { jsx as e, jsxs as d } from "react/jsx-runtime";
import { memo as f, useCallback as g, useMemo as y } from "react";
import { Dropdown as h } from "antd";
import { u as c } from "../../../styled-components.browser.esm-BFmoFexH.js";
import { F as k } from "../../../ChevronDownIcon-CUajCkYx.js";
import { IconContainer as t } from "@biron-data/react-components";
import { a as v, f as x } from "../../../filters-Cwo0Aj2k.js";
import { useLanguageResolver as C } from "@biron-data/react-contexts";
import { useCurrentIcon as w } from "./utils.js";
const E = f(function({
  filter: r,
  handleFilterChange: n,
  getPopupContainer: a
}) {
  const i = C(), m = w(r), p = g((o) => {
    n(Object.assign({}, {
      ...r,
      predicate: {
        ...r.predicate,
        negate: o.key === v.negate
      }
    }));
  }, [r, n]), l = y(() => {
    const o = [];
    return x.forEach((u, s) => {
      o.push({
        key: s,
        label: i.get(`filterType.${s}`),
        icon: /* @__PURE__ */ e(t, { children: /* @__PURE__ */ e(u, {}) })
      });
    }), o;
  }, [i]);
  return /* @__PURE__ */ e(
    I,
    {
      menu: { items: l, onClick: p },
      trigger: ["click"],
      getPopupContainer: a,
      overlayClassName: "filter-type",
      children: /* @__PURE__ */ d(j, { children: [
        /* @__PURE__ */ e(t, { size: 16, children: /* @__PURE__ */ e(m, {}) }),
        /* @__PURE__ */ e(t, { size: 16, children: /* @__PURE__ */ e(k, {}) })
      ] })
    }
  );
}), I = c(h)`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: start;
    margin: 0;
    padding: 0;
    cursor: pointer;
`, j = c.div`
    height: 100%;
    gap: 5px;
    color: var(--light-grey);

    &:hover {
        color: var(--primary);
    }
`;
export {
  E as default
};
//# sourceMappingURL=FilterTypeDropDown.js.map
